import {useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {RolePermissionType} from '../../../../../../backend/enums/role-permission-type';
import {
  RemindersContent,
  RemindersUnavailable,
} from '../../../../../../components/reminders-content/reminders-content';
import {useAuth} from '../../../../../../contexts/auth/context';
import {EntityUserRemindersRepository} from '../../../../../../repositories/entity-user-reminders';

export function ProfessionalRemindersPage() {
  const {entityId, id: seniorId} = useParams<{entityId: string; id: string}>();
  const {state, hasWritePermission} = useAuth();
  const api = useMemo(
    () => new EntityUserRemindersRepository(entityId, seniorId),
    [entityId, seniorId]
  );
  const selectedEntityId = state.session?.selectedAffiliation?.entity?.id;

  if (!entityId || !seniorId || selectedEntityId !== entityId) return <RemindersUnavailable />;

  return (
    <RemindersContent
      key={`${entityId}:${seniorId}`}
      seniorId={seniorId}
      api={api}
      canWrite={hasWritePermission(RolePermissionType.Seniors_PersonalData_Reminders)}
    />
  );
}
